/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAllFormElementConfigurations = /* GraphQL */ `
  query GetAllFormElementConfigurations {
    getAllFormElementConfigurations {
      name
      attributes
    }
  }
`;
export const getAllMerchantForms = /* GraphQL */ `
  query GetAllMerchantForms {
    getAllMerchantForms {
      merchantCode
      formElements {
        formElement
        sequenceNumber
      }
    }
  }
`;
export const getAllMerchantFormData = /* GraphQL */ `
  query GetAllMerchantFormData {
    getAllMerchantFormData {
      merchantCode
      formDataGUID
      formData
      dateSubmitted
    }
  }
`;
export const getAllMerchantCountries = /* GraphQL */ `
  query GetAllMerchantCountries {
    getAllMerchantCountries {
      name
      states {
        name
      }
    }
  }
`;
export const getAllMerchants = /* GraphQL */ `
  query GetAllMerchants {
    getAllMerchants {
      aliasCode
      name
      slogan
      phoneNumber
      email
      location {
        streetAddress1
        streetAddress2
        countryName
        stateName
      }
    }
  }
`;
export const getFormElementConfiguration = /* GraphQL */ `
  query GetFormElementConfiguration(
    $params: QueryGetFormElementConfigurationParamsInput!
  ) {
    getFormElementConfiguration(params: $params) {
      name
      attributes
    }
  }
`;
export const getMerchantForm = /* GraphQL */ `
  query GetMerchantForm($params: QueryGetMerchantFormParamsInput!) {
    getMerchantForm(params: $params) {
      merchantCode
      formElements {
        formElement
        sequenceNumber
      }
    }
  }
`;
export const getMerchantFormData = /* GraphQL */ `
  query GetMerchantFormData(
    $params: QueryGetMerchantFormDataParamsInput!
    $query: QueryGetMerchantFormDataQueryInput!
  ) {
    getMerchantFormData(params: $params, query: $query) {
      merchantCode
      formDataGUID
      formData
      dateSubmitted
    }
  }
`;
export const getMerchantFormDataByDate = /* GraphQL */ `
  query GetMerchantFormDataByDate(
    $params: QueryGetMerchantFormDataByDateParamsInput!
    $query: QueryGetMerchantFormDataByDateQueryInput!
  ) {
    getMerchantFormDataByDate(params: $params, query: $query) {
      merchantCode
      formDataGUID
      formData
      dateSubmitted
    }
  }
`;
export const getMerchantFormDataByMerchantCode = /* GraphQL */ `
  query GetMerchantFormDataByMerchantCode(
    $params: QueryGetMerchantFormDataByMerchantCodeParamsInput!
  ) {
    getMerchantFormDataByMerchantCode(params: $params) {
      merchantCode
      formDataGUID
      formData
      dateSubmitted
    }
  }
`;
export const getMerchant = /* GraphQL */ `
  query GetMerchant($params: QueryGetMerchantParamsInput!) {
    getMerchant(params: $params) {
      aliasCode
      name
      slogan
      phoneNumber
      enableReceiptEmails
      email
      emailDisplayName
      taxId
      businessHours
      location {
        streetAddress1
        streetAddress2
        countryName
        stateName
      }
    }
  }
`;
export const getMerchantCountry = /* GraphQL */ `
  query GetMerchantCountry($params: QueryGetMerchantCountryParamsInput!) {
    getMerchantCountry(params: $params) {
      name
      states {
        name
      }
    }
  }
`;
export const getTransactionResult = /* GraphQL */ `
  query GetTransactionResult($params: QueryGetTransactionResultParamsInput!) {
    getTransactionResult(params: $params) {
      approved
      description
      detail {
        orderNumber
        authorizationNumber
        transactionDate
        amount
        currency
        tenantAlias
        intentId
        responseCode
        reasonCode
        paddedCardNumber
        firstName
        lastName
        email
        returnUrl
      }
    }
  }
`;
export const searchTransaction = /* GraphQL */ `
  query SearchTransaction(
    $query: QuerySearchTransactionQueryInput
    $body: QuerySearchTransactionBodyInput
  ) {
    searchTransaction(query: $query, body: $body) {
      itemCount
      data {
        transactionId
        amount
        orderNumber
        referenceNumber
        authCode
        transactionDate
        lastModified
        transactionStatus
        firstName
        lastName
        email
        customFields
      }
      message
      nextToken
    }
  }
`;
export const getTransactionAmountTotal = /* GraphQL */ `
  query GetTransactionAmountTotal(
    $query: TransactionTotalAmountRequest!
  ) {
    getTransactionAmountTotal(query: $query) {
      isSuccessful
      Total
      Type
    }
  }
`;
export const getPaymentRequestTotals = /* GraphQL */ `
  query GetPaymentRequestTotals(
    $query: PaymentRequestTotalsAmountRequest!
  ) {
    getPaymentRequestTotals(query: $query) {
      isSuccessful
      Total
      Type
    }
  }
`;
export const getCountry = /* GraphQL */ `
  query GetCountry($id: ID!) {
    getCountry(id: $id) {
      id
      code
      name
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listCountrys = /* GraphQL */ `
  query ListCountrys(
    $filter: ModelCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCountrys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCountries = /* GraphQL */ `
  query SyncCountries(
    $filter: ModelCountryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCountries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        code
        name
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCurrency = /* GraphQL */ `
  query GetCurrency($id: ID!) {
    getCurrency(id: $id) {
      id
      code
      numcode
      name
      exponent
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listCurrencys = /* GraphQL */ `
  query ListCurrencys(
    $filter: ModelCurrencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCurrencys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        numcode
        name
        exponent
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCurrencies = /* GraphQL */ `
  query SyncCurrencies(
    $filter: ModelCurrencyFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCurrencies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        code
        numcode
        name
        exponent
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getState = /* GraphQL */ `
  query GetState($id: ID!) {
    getState(id: $id) {
      id
      name
      abbreviation
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listStates = /* GraphQL */ `
  query ListStates(
    $filter: ModelStateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        abbreviation
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncStates = /* GraphQL */ `
  query SyncStates(
    $filter: ModelStateFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncStates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        abbreviation
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;

export const getMerchantsData = /* GraphQL */ `
 query GetMerchantsData {
    getMerchantsData{
      success
      data {
        merchantName
        signUpDate
        nextPaymentDate
        lastPaymentDate
        contactEmail
      }
      error
    }
  }
`;
export const getMerchantDetails = /* GraphQL */ `
 query GetMerchantDetails($merchantName: String!) {
  getMerchantDetails(merchantName: $merchantName){
      success
      data {
        merchant {
          merchantName
          signUpDate
          nextPaymentDate
          lastPaymentDate
          contactEmail
        }
        payments {
          merchantName
          paymentDate
        }
      }
      error
    }
  }
`;
 
export const getPromoCodeById = /* GraphQL */ `
  query GetPromoCodeById($id: String!)  {
    getPromoCodeById(id: $id) {
      success
      error
      promotionalCode {
      id
      description
      name
      code
      uses
      isActive
      discount {
        isAvailable
        amount
        type
      }
      requirements {
        isAvailable
        startDate
        endDate
        customerEmail
      }
      recurring {
        isAvailable
        
        freeTrials {
          frequency
          period
        }
      }
      createdBy
    }
    }

  }
`

